module.exports = __webpack_public_path__ + "img/CP.a9c793be.webp";